module.exports = __webpack_public_path__ + "static/media/timer.0d7437bc.svg";